/** @file The IK constraint that ends at bone P: its last chain bone is P, else P's parent (R-E1-12). */
import type { Id } from '@pose2d/format/types';
import type { ToolContext } from '../../panels/viewport/viewportTypes';
import { ikRef, type IkRef } from '../transform/ikRef';

/** The suggestIk convention puts the chain above the end bone, so the parent match is the common one. */
export function ikEndingAt(ctx: Pick<ToolContext, 'doc' | 'maps'>, bone: Id): IkRef | null {
  const all = Object.values(ctx.doc.constraints);
  const parent = ctx.doc.bones[bone]?.parent ?? null;
  const c = all.find((k) => k.bones.at(-1) === bone) ?? all.find((k) => parent !== null && k.bones.at(-1) === parent);
  return c === undefined ? null : ikRef(ctx.maps, c);
}
